const getMyStatement = payload => ({
  type: "GET_MY_STATEMENT",
  payload
});

export default {
    getMyStatement
};
